module.exports = __webpack_public_path__ + "media/images/icons/flags/FI-3c4bf684331a40ee0f6d8550b569d443.svg";